import { createListenerMiddleware } from '@reduxjs/toolkit'
import { setAppTokens, setAppUrl } from '@Store/slices/remoteApp'
import Sentry from '@Utils/Sentry'

const appUrlMiddleware = createListenerMiddleware()
appUrlMiddleware.startListening({
  actionCreator: setAppUrl,
  effect: async (action, listenerApi) => {
    // This is now the sole token entry path (localStorage persistence was
    // dropped), so a malformed `?token=` param must not throw an uncaught
    // error inside the listener — guard the decode/parse and log instead.
    try {
      const url = new URL(action.payload)
      const encodedTokens = url.searchParams?.get('token')
      if (!encodedTokens) return
      const tokens = JSON.parse(atob(encodedTokens))
      listenerApi.dispatch(setAppTokens(tokens))
    } catch (error) {
      Sentry.message(
        `[appUrlMiddleware] Failed to decode embedded token: ${String(error)}`,
        'error',
      )
    }
  },
})

export default appUrlMiddleware
